(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["freddie-header"]) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.fhdrReady) return;
    root.dataset.fhdrReady = '1';
    var timeEl = root.querySelector('[data-fhdr-time]');
    var dateEl = root.querySelector('[data-fhdr-date]');
    if (timeEl || dateEl) {
      var tick = function () {
        var now = new Date();
        if (timeEl) timeEl.textContent = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
        if (dateEl) dateEl.textContent = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      };
      tick();
      setInterval(tick, 15000);
    }

    var toggle = root.querySelector('[data-fhdr-toggle]');
    var nav = root.querySelector('.fhdr-nav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  function boot() { document.querySelectorAll('[data-fhdr]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freddie-password"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (root.dataset.fpwReady) return;
    root.dataset.fpwReady = '1';

    /* Clock */
    var timeEl = root.querySelector('[data-fpw-time]');
    var dateEl = root.querySelector('[data-fpw-date]');
    function tick() {
      var now = new Date();
      if (timeEl) timeEl.textContent = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      if (dateEl) dateEl.textContent = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
    tick();
    setInterval(tick, 15000);

    /* Newsletter minimize */
    var win = root.querySelector('[data-fpw-window]');
    var minBtn = root.querySelector('[data-fpw-min]');
    if (win && minBtn) minBtn.addEventListener('click', function () { win.classList.toggle('is-min'); });

    /* Newsletter AJAX submit (spinner, no page reload) */
    var form = root.querySelector('form.fpw-newsletter');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        var errorEl = form.querySelector('[data-newsletter-error]');
        var fields = form.querySelector('[data-newsletter-fields]');
        var success = form.querySelector('[data-newsletter-success]');
        var btn = form.querySelector('[data-newsletter-submit]');
        var spinner = form.querySelector('.fpw-spinner');
        var label = form.querySelector('.fpw-newsletter__btn-label');

        if (errorEl) { errorEl.hidden = true; }
        if (!email || !email.value || !email.checkValidity()) {
          if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.hidden = false; }
          if (email) email.focus();
          return;
        }

        if (btn) btn.disabled = true;
        if (label) label.hidden = true;
        if (spinner) spinner.hidden = false;

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        }).then(function () {
          if (fields) fields.hidden = true;
          if (success) success.hidden = false;
        }).catch(function () {
          if (btn) btn.disabled = false;
          if (label) label.hidden = false;
          if (spinner) spinner.hidden = true;
          if (errorEl) { errorEl.textContent = 'Something went wrong. Please try again.'; errorEl.hidden = false; }
        });
      });
    }

    /* Drag folders (desktop only) */
    var stage = root.querySelector('[data-fpw-stage]');
    if (!stage) return;
    var z = 10;
    var desktop = function () { return window.matchMedia('(min-width: 750px)').matches; };

    root.querySelectorAll('[data-fpw-folder]').forEach(function (el) {
      var dragging = false, moved = false, sx = 0, sy = 0, ox = 0, oy = 0, downX = 0, downY = 0;

      el.addEventListener('pointerdown', function (e) {
        if (!desktop() || (e.button != null && e.button !== 0)) return;
        dragging = true; moved = false;
        downX = e.clientX; downY = e.clientY;
        var rect = el.getBoundingClientRect();
        var srect = stage.getBoundingClientRect();
        ox = e.clientX - rect.left;
        oy = e.clientY - rect.top;
        sx = srect.left; sy = srect.top;
        el.style.left = (rect.left - srect.left) + 'px';
        el.style.top = (rect.top - srect.top) + 'px';
        el.style.zIndex = ++z;
        el.classList.add('is-dragging');
        el.setPointerCapture(e.pointerId);
      });

      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (Math.abs(e.clientX - downX) > 4 || Math.abs(e.clientY - downY) > 4) moved = true;
        var nx = e.clientX - sx - ox;
        var ny = e.clientY - sy - oy;
        var maxX = stage.clientWidth - el.offsetWidth;
        var maxY = stage.clientHeight - el.offsetHeight;
        el.style.left = Math.max(0, Math.min(nx, maxX)) + 'px';
        el.style.top = Math.max(0, Math.min(ny, maxY)) + 'px';
      });

      function end(e) {
        if (!dragging) return;
        dragging = false;
        el.classList.remove('is-dragging');
        try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);

      /* Suppress navigation if it was a drag */
      el.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); moved = false; }
      });
    });
  }

  function init() { document.querySelectorAll('[data-fpw]').forEach(initRoot); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
